/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import React, { useEffect, ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { gql, useMutation, useQuery } from '@apollo/client';
import { useToken } from '../../hooks';
import { getRedirectUrlFromStatus } from '../../utils/status-router';
import config from '../../utils/config';

type ParticipantOutcome = {
	initParticipant: {
		url: string;
		status: string;
	};
};

const userCodeQuery = gql`
	query {
		participant {
			userCode
		}
	}
`;

const initParticipantMutation = gql`
	mutation {
		initParticipant {
			status
			url
		}
	}
`;

type Props = {
	isModeratedScreener?: boolean;
	isModeratedStudy?: boolean;
};

const defaultProps = {
	isModeratedScreener: false,
	isModeratedStudy: false,
};

const InitParticipant = ({ isModeratedScreener, isModeratedStudy }: Props): ReactElement => {
	const history = useHistory();
	const token = useToken();

	const { data: queryData } = useQuery(userCodeQuery);

	const [initParticipant, { called: calledInit }] = useMutation<ParticipantOutcome>(initParticipantMutation, {
		onCompleted(data) {
			if (data?.initParticipant) {
				const { status, url } = data.initParticipant;
				if (url) {
					window.location.href = url;
				} else if (status && token) {
					history.replace(getRedirectUrlFromStatus(status, token, isModeratedScreener, isModeratedStudy));
				} else {
					history.replace('/forbidden');
				}
			}
		},
	});

	const { screen, innerHeight, innerWidth } = window;

	useEffect(() => {
		if (!calledInit) {
			initParticipant();
		}
	}, [initParticipant, calledInit]);

	const userCode = queryData?.participant?.userCode;
	if (!userCode) {
		return <div id="loading" />;
	}

	const { server3Url } = config();
	const imageUrl = `${server3Url}/s/ui.aspx?uc=${userCode}&sr=${screen.width}x${screen.height}&vp=${innerWidth}x${innerHeight}`;

	return <img src={imageUrl} alt="" />;
};

InitParticipant.defaultProps = defaultProps;

export default InitParticipant;
